// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"styles_Pagination__ajr4z","hidden":"styles_hidden__fr5gI","content":"styles_content__XA7OF","link":"styles_link__YDQyl","active":"styles_active__RSBx7"};